import { useState } from 'react';

export const useMoreActionsMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const closeMenu = (e) => {
    setAnchorEl(null);
    e.stopPropagation();
  };

  return { anchorEl, openMenu, closeMenu };
};
